import { useState, useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import { useContext } from 'react';
import { parseISO, differenceInDays, differenceInMinutes } from 'date-fns';
import { useNavigate } from 'react-router-dom';

export default function HolidayBook({ holiday = [] }) {
  const user = useContext(AuthContext);
  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState([]);
  const [policy, setPolicy] = useState([]);
  const [holidayList, setHolidayList] = useState(Array.isArray(holiday) ? holiday : []);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reason, setReason] = useState('');
  const [holidayLength, setHolidayLength] = useState('Full'); // Track holiday length
  const [amPm, setAmPm] = useState('AM'); // For Half Day AM/PM
  const [startEnd, setStartEnd] = useState('Start'); // For Hour Start/End
    const [emergency, setEmergency] = useState('No'); // For Emergency Leave
  const [unpaidBreak, setUnpaidBreak] = useState(0); // For Unpaid Break

  const token = localStorage.getItem('token');

  console.log('unpaid' + unpaidBreak);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await fetch('https://api.insightos.co.uk/api/staff', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',

        });

        if (!response.ok) {
          throw new Error('Failed to fetch staff');
        }

        const response2 = await fetch('https://api.insightos.co.uk/api/policies', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (!response2.ok) {
          throw new Error('Failed to fetch policies');
        }

        const data2 = await response2.json();
        const policyData = data2.data;

        setPolicy(policyData);

        console.log('Policy Data:', policyData);
        setUnpaidBreak(policyData[0].UnpaidBreak);



        const data = await response.json();

        const filterStaff =
          user.access === 'admin'
            ? data.data
            : data.data.filter((staff) => staff.Role === user.role);

        const userDetails = filterStaff.filter((staff) => staff.id === user.id);

        setUserDetails(userDetails);

      } catch (error) {
        console.error('Error fetching staff:', error);
      }
    };

    fetchStaff();
  }, [user.access, user.id, user.role]);

  useEffect(() => {
    const fetchHoliday = async () => {
      try {
        const response = await fetch('https://api.insightos.co.uk/api/holiday', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error('Failed to fetch holiday data');
        }

        const data = await response.json();
        const allHoliday = data?.data || [];
        const filteredHoliday =
          user.access === 'admin'
            ? allHoliday
            : allHoliday.filter((item) => item.Role === user.role);

        setHolidayList(Array.isArray(filteredHoliday) ? filteredHoliday : []);
      } catch (error) {
        console.error('Error fetching holidays:', error);
        setHolidayList(Array.isArray(holiday) ? holiday : []);
      }
    };

    fetchHoliday();
  }, [user.access, user.role, holiday]);

  const goToHolidayHome = () => {
    if (user.access === 'staff') {
      navigate('/staffholiday');
      return;
    }
    navigate('/managerholiday');
  };

  const handleHolidayLengthChange = (e) => {
    setHolidayLength(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if isHoliday is true, then return early and don't submit the form and same for isOverEntitlement
    if (isHoliday || isOverEntitlement) {
      return;
    }


    const response = await fetch('https://api.insightos.co.uk/api/holidayrequests', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        },
        credentials: 'include',

        body: JSON.stringify({
            FromDate: fromDate,
            ToDate: toDate,
            Name: userDetails[0].Name,
            Policy : policy[0].HolidayType,
            Notes: reason,
            Approved: 0,
            Role: userDetails[0].Role,
            StaffId: userDetails[0].id,
            Emergency: 'No',
            ContractedHours : userDetails[0].ContractedHours,
            ContractedDays : userDetails[0].ContractedDays,
            Hours : totalHolidayHours,
            FullDay : holidayLength + amPm ,

        }),

    });

    if (!response.ok) {
        console.error('Failed to submit holiday request');
        return;
    }

    const data = await response.json();
    console.log('Holiday request submitted:', data);
    goToHolidayHome();
  };

  const calculateHolidayDetails = () => {
    if (!userDetails.length || !policy.length) return { totalHolidayHours: 0, remainingTime: 0 };

    const currentUser = userDetails[0];
    const currentPolicy = policy[0];

    let totalHolidayHours = 0;
    let remainingTime = 0;

    const from = parseISO(fromDate);
    const to = parseISO(toDate);
    const daysBetween = differenceInDays(to, from);

    // check if there is no other holidays in the same period using holiday prop

    let isOverEntitlement = false;



    const isHoliday = holidayList.some((h) => {
        const hFrom = parseISO(h.FromDate);
        const hTo = parseISO(h.ToDate);
        return (from >= hFrom && from <= hTo) || (to >= hFrom && to <= hTo);
    });

    if (isHoliday) {
        console.log('There is a holiday in the same period');
        return { totalHolidayHours: 0, remainingTime: 0, isHoliday: true };
    }

    

    if (currentPolicy.HolidayType === 'Hours') {
      // For holiday type Hours, calculate the total hours
      const contractedHours = currentUser.ContractedHours / currentUser.ContractedDays;
      totalHolidayHours = daysBetween * contractedHours;
      remainingTime = currentUser.HolidayEntitlement - currentUser.HolidayTaken - totalHolidayHours;

        // if the remaining time is negative, then return over entitlement

        if (remainingTime < 0) {
            isOverEntitlement = true;
            remainingTime = 0; // Optional: Can set this to 0, or keep it negative to highlight over-entitlement
            totalHolidayHours = 0
          }

      
      
    }

    if (currentPolicy.HolidayType === 'Days') {
      // For holiday type Days, calculate the total days and convert to hours
     totalHolidayHours = daysBetween 
        remainingTime = currentUser.HolidayEntitlement - currentUser.HolidayTaken - totalHolidayHours;

        if (remainingTime < 0) {
            isOverEntitlement = true;
            remainingTime = 0; // Optional: Can set this to 0, or keep it negative to highlight over-entitlement
            totalHolidayHours = 0
          }


      // if the remaining time is negative, then return over entitlement
    }

    if (holidayLength === 'Half') {
      // For Half Day holiday, assume 4 hours for AM/PM
      totalHolidayHours = currentUser.ContractedHours / currentUser.ContractedDays / 2; // Half day equivalent
        remainingTime = currentUser.HolidayEntitlement - currentUser.HolidayTaken - totalHolidayHours;

        if (remainingTime < 0) {
            isOverEntitlement = true;
            remainingTime = 0; // Optional: Can set this to 0, or keep it negative to highlight over-entitlement
            totalHolidayHours = 0
        }
    }

    if (holidayLength === 'Hour') {
      // For specific Hours, you can also manually calculate the hours
      totalHolidayHours = differenceInMinutes(to, from) / 60; // Minutes to hours
      remainingTime = currentUser.HolidayEntitlement - currentUser.HolidayTaken - totalHolidayHours;
    }

    return { totalHolidayHours, remainingTime, isHoliday: false, isOverEntitlement };
  };


  const { totalHolidayHours, remainingTime, isHoliday, isOverEntitlement } = calculateHolidayDetails();

  return (
    <div className="w-full px-0 sm:px-4 py-0 sm:py-4">
      {userDetails.map((mainUser) => (
        <form onSubmit={handleSubmit} key={mainUser.id} className="flex flex-col gap-4">
            {/* Info card */}
            <div className="p-4 bg-gray-100 rounded-none sm:rounded-lg border-0 sm:border border-gray-200">
              <p className="text-xs sm:text-sm font-semibold text-blue-700">{mainUser.Name}</p>
              <p className="text-xs sm:text-sm font-semibold text-blue-700">{mainUser.Role}</p>
              {policy[0].HolidayType === 'Hours' && (
                <div className="mt-1 space-y-0.5">
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Entitlement: {mainUser.HolidayEntitlement} hrs</p>
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Taken: {mainUser.HolidayTaken} hrs</p>
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Remaining: {mainUser.HolidayEntitlement - mainUser.HolidayTaken} hrs</p>
                </div>
              )}
              {policy[0].HolidayType === 'Days' && (
                <div className="mt-1 space-y-0.5">
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Entitlement: {mainUser.HolidayEntitlement} days</p>
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Taken: {mainUser.HolidayTaken} days</p>
                  <p className="text-xs sm:text-sm font-semibold text-blue-700">Remaining: {mainUser.HolidayEntitlement - mainUser.HolidayTaken} days</p>
                </div>
              )}
            </div>

            {/* Status summary card */}
            <div className={`p-4 border-2 rounded-none sm:rounded-lg ${
              isHoliday || isOverEntitlement ? 'bg-red-500 border-red-500 animate-pulse' : 'border-gray-300'
            }`}>
              {isHoliday && <p className="text-xs sm:text-sm font-semibold text-white mb-1">There is a holiday in the same period</p>}
              {isOverEntitlement && <p className="text-xs sm:text-sm font-semibold text-white mb-1">Your holiday request is over your entitlement</p>}
              <h3 className="text-xs sm:text-sm font-semibold text-blue-700">Selected Details</h3>
              <p className="text-xs sm:text-sm font-semibold text-gray-900">Length: {holidayLength}</p>
              <p className="text-xs sm:text-sm font-semibold text-gray-900">Start: {fromDate}</p>
              <p className="text-xs sm:text-sm font-semibold text-gray-900">End: {toDate}</p>
              <p className="text-xs sm:text-sm font-semibold text-gray-900">Reason: {reason}</p>
              <p className="text-xs sm:text-sm font-semibold text-blue-700 mt-1">Hours Taken: <span className="text-gray-900">{totalHolidayHours.toPrecision()}</span></p>
              <p className="text-xs sm:text-sm font-semibold text-blue-700">Remaining: <span className="text-gray-900">{remainingTime.toPrecision()}</span></p>
              {holidayLength === 'Half' && <p className="text-xs sm:text-sm font-semibold text-gray-900">AM/PM: {amPm}</p>}
              {holidayLength === 'Hour' && <p className="text-xs sm:text-sm font-semibold text-gray-900">Start/End: {startEnd}</p>}
            </div>

            <div className="flex flex-col gap-3 px-0 sm:px-1">
              {/* Holiday Length */}
              <div>
                <label htmlFor="fullDay" className="block text-xs sm:text-sm font-medium text-gray-900">Holiday Length</label>
                <select id="fullDay" name="fullDay" value={holidayLength} onChange={handleHolidayLengthChange}
                  className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600">
                  <option value="Full">Full Day</option>
                  <option value="Half">Half Day</option>
                  <option value="Hour">Hours</option>
                  <option value="Block">Block Booking</option>
                </select>
              </div>

              {/* Full Day date input */}
              {holidayLength === 'Full' && (
                <div>
                  <label className="block text-xs sm:text-sm font-medium text-gray-900">Date</label>
                  {isHoliday && fromDate && (
                    <div className="mt-1 flex items-center gap-2 p-3 bg-red-50 border border-red-300 rounded-md">
                      <svg className="w-4 h-4 text-red-600 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                      </svg>
                      <p className="text-xs sm:text-sm font-semibold text-red-700">This day is already booked</p>
                    </div>
                  )}
                  <input type="date" value={fromDate}
                    onChange={(e) => { setFromDate(e.target.value); setToDate(e.target.value); }}
                    className={`mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-indigo-600 ${
                      isHoliday && fromDate ? 'ring-red-400' : 'ring-gray-300'
                    }`}
                  />
                </div>
              )}

              {/* Half Day date + AM/PM */}
              {holidayLength === 'Half' && (
                <>
                  <div>
                    <label className="block text-xs sm:text-sm font-medium text-gray-900">Date</label>
                    <input type="date" value={fromDate}
                      onChange={(e) => { setFromDate(e.target.value); setToDate(e.target.value); }}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                    />
                  </div>
                  <div>
                    <label htmlFor="amPm" className="block text-xs sm:text-sm font-medium text-gray-900">AM or PM</label>
                    <select id="amPm" name="amPm" value={amPm} onChange={(e) => setAmPm(e.target.value)}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600">
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </>
              )}

              {/* Hour start/end datetime */}
              {holidayLength === 'Hour' && (
                <>
                  <div>
                    <label className="block text-xs sm:text-sm font-medium text-gray-900">Start Date &amp; Time</label>
                    <input type="datetime-local" value={fromDate} onChange={(e) => setFromDate(e.target.value)}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                    />
                  </div>
                  <div>
                    <label className="block text-xs sm:text-sm font-medium text-gray-900">End Date &amp; Time</label>
                    <input type="datetime-local" value={toDate} onChange={(e) => setToDate(e.target.value)}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                    />
                  </div>
                </>
              )}

              {/* Block Booking from/to */}
              {holidayLength === 'Block' && (
                <>
                  <div>
                    <label className="block text-xs sm:text-sm font-medium text-gray-900">From Date</label>
                    <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                    />
                  </div>
                  <div>
                    <label className="block text-xs sm:text-sm font-medium text-gray-900">To Date</label>
                    <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)}
                      className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                    />
                  </div>
                </>
              )}

              {/* Reason */}
              <div>
                <label htmlFor="reason" className="block text-xs sm:text-sm font-medium text-gray-900">Reason for Holiday</label>
                <textarea id="reason" name="reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={3}
                  className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                />
              </div>

              {/* Emergency */}
              <div>
                <label htmlFor="emergency" className="block text-xs sm:text-sm font-medium text-gray-900">Emergency Leave (Optional)</label>
                <select id="emergency" name="emergency" onChange={(e) => setEmergency(e.target.value)}
                  className="mt-1 block w-full rounded-md border-0 py-2 text-xs sm:text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600">
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>

              {/* Submit */}
              <div className="grid grid-cols-2 gap-2 mt-1">
                <button
                  type="button"
                  onClick={goToHolidayHome}
                  className="w-full bg-gray-100 text-gray-700 rounded-md py-2.5 px-4 text-sm font-medium hover:bg-gray-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-component="holiday-request"
                  data-feature="submit_holiday_request_post"
                  data-time-saved="10"
                  className="w-full bg-indigo-600 text-white rounded-md py-2.5 px-4 text-sm font-medium hover:bg-indigo-700"
                >
                  Submit Request
                </button>
              </div>
            </div>
        </form>
      ))}
    </div>
  );
}
